module.exports = __webpack_public_path__ + "static/media/sara.591d794c.jpg";